export const getCustomUrlWithAnalytics = ({
  canonicalUrl,
  configureProduct,
  customExperience,
  blindsHost,
  hover,
  info
}) => {
  let productURL = canonicalUrl;
  const regex = /\/p\//gi;
  const customBase = customExperience ? `/p/${customExperience}/` : '/p/custom-blinds/';
  const customProductUrl = canonicalUrl && canonicalUrl.replace(regex, customBase);
  if (hover) {
    productURL = (customExperience && configureProduct)
      ? `${blindsHost}${customProductUrl}` : canonicalUrl;
  } else if (configureProduct) {
    productURL = `${blindsHost}${customProductUrl}`;
  }
  // add sponsored tracking info in productURL
  if (!!info?.isSponsored && !!info?.sponsoredMetadata) {
    const campaignId = info?.sponsoredMetadata?.campaignId || '';
    const placementId = info?.sponsoredMetadata?.placementId || '';
    const slotId = info?.sponsoredMetadata?.slotId || '';

    productURL += (productURL.indexOf('?') > -1) ? '&' : '?';
    productURL += `ITC=AUC-${campaignId}-${placementId}-${slotId}`;
  }
  return productURL;
};
